import { getCurrentUrl } from '@Engage.Core';
import { ConnextUserAgent } from './ConnextUserAgent';
class UserAgent {
    constructor() {
        this.connextDeviceDetector = {
            UA: window.navigator.userAgent,
            Device: {
                browser: {
                    name: ConnextUserAgent.userAgent.getBrowser(),
                    isFirefox: () => ConnextUserAgent.userAgent.getBrowser() == ConnextUserAgent.BrowserTypes.Firefox,
                    isChrome: () => ConnextUserAgent.userAgent.getBrowser() == ConnextUserAgent.BrowserTypes.Chrome,
                    isIE: () => ConnextUserAgent.userAgent.getBrowser() == ConnextUserAgent.BrowserTypes.IE,
                    isEdge: () => ConnextUserAgent.userAgent.getBrowser() == ConnextUserAgent.BrowserTypes.Edge,
                    isSafari: () => ConnextUserAgent.userAgent.getBrowser() == ConnextUserAgent.BrowserTypes.Safari,
                    isFacebook: () => ConnextUserAgent.userAgent.getBrowser() == ConnextUserAgent.BrowserTypes.Facebook
                },
                platform: {
                    type: ConnextUserAgent.userAgent.getDeviceType(),
                    isDesktop: () => ConnextUserAgent.userAgent.desktop(),
                    isMobile: () => ConnextUserAgent.userAgent.mobile(),
                    isTablet: () => ConnextUserAgent.userAgent.tablet()
                },
                os: {
                    name: ConnextUserAgent.userAgent.getOS(),
                    isIOS: () => ConnextUserAgent.userAgent.isIOS()
                }
            },
            Browsers: [],
            OsList: [],
            Platforms: []
        };
        if (!window.DeviceDetector) {
            this.deviceDetector = this.connextDeviceDetector;
        }
        else {
            this.deviceDetector = window.DeviceDetector;
        }
    }
    getDeviceType() {
        let deviceType = this.deviceDetector.Device.platform.type;
        if (deviceType == 'Desktop' && (/Macintosh/.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0)) {
            return 'Tablet';
        }
        else {
            return deviceType;
        }
    }
    getOS() {
        const device = this.deviceDetector.Device;
        const version = device.os.version ? device.os.version : '';
        return device.os.name + version;
    }
    getBrowser() {
        return this.isDetectBrowser() ? this.deviceDetector.Device.browser.name : this.connextDeviceDetector.Device.browser.name;
    }
    isChrome() {
        return this.isDetectBrowser() && this.deviceDetector.Device.browser.isChrome ? this.deviceDetector.Device.browser.isChrome() : this.connextDeviceDetector.Device.browser.isChrome();
    }
    isFirefox() {
        return this.isDetectBrowser() && this.deviceDetector.Device.browser.isFirefox ? this.deviceDetector.Device.browser.isFirefox() : this.connextDeviceDetector.Device.browser.isFirefox();
    }
    isIE() {
        return this.isDetectBrowser() && this.deviceDetector.Device.browser.isIE ? this.deviceDetector.Device.browser.isIE() : this.connextDeviceDetector.Device.browser.isIE();
    }
    isEdge() {
        return this.isDetectBrowser() && this.deviceDetector.Device.browser.isEdge ? this.deviceDetector.Device.browser.isEdge() : this.connextDeviceDetector.Device.browser.isEdge();
    }
    isSafari() {
        return this.isDetectBrowser() && this.deviceDetector.Device.browser.isSafari ? this.deviceDetector.Device.browser.isSafari() : this.connextDeviceDetector.Device.browser.isSafari();
    }
    isFacebook() {
        return this.isDetectBrowser() && this.deviceDetector.Device.browser.isFacebook ? this.deviceDetector.Device.browser.isFacebook() : this.connextDeviceDetector.Device.browser.isFacebook();
    }
    isIOS() {
        if (this.isDetectOS()) {
            return this.deviceDetector.Device.os.isIOS();
        }
        else {
            return false;
        }
    }
    getBrowserVersion() {
        if (!this.isDetectBrowser()) {
            return null;
        }
        var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|edg|version|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return tem[1];
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null)
                return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        return M[2] ? M[2] : null;
    }
    isDetectOS() {
        return !!(this.deviceDetector.Device.os && this.deviceDetector.Device.os.name);
    }
    isDetectBrowser() {
        return !!(this.deviceDetector.Device.browser && this.deviceDetector.Device.browser.name);
    }
    isDesktop() {
        return this.deviceDetector.Device.platform.isDesktop();
    }
    isMobile() {
        return this.deviceDetector.Device.platform.isMobile();
    }
    isTablet() {
        return this.deviceDetector.Device.platform.isTablet();
    }
    getUserMeta() {
        return {
            Browser: this.getBrowser(),
            OS: this.getOS(),
            deviceType: this.getDeviceType(),
            URL: getCurrentUrl()
        };
    }
}
export const userAgent = new UserAgent();
